import { useState, forwardRef, useEffect } from 'react'
import { Button, Dialog, Grid, IconButton, Slide } from '@mui/material'
import { Close } from '@mui/icons-material'
import { Worker, Viewer } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import { useAlertContext } from '../context'

const Transition = forwardRef(function Transition (props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const PDFFileDialog = ({ open, handleClose, file, downloadFileName }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin()
    const { setAlertSimple } = useAlertContext()

    const handleDownload = async () => {
        if (!file) return
        try {
            const response = await fetch(file)
            if (!response.ok) {
                throw new Error('Network response was not ok')
            }
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            const filename = downloadFileName || file.split('/').pop().split('?')[0] || 'download.pdf'
            a.setAttribute('download', filename)
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
        } catch (error) {
            console.error('Error downloading the PDF:', error)
            setAlertSimple('Error de Descarga', 'No se pudo descargar el archivo PDF.')
        }
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <IconButton
                    style={{ position: 'absolute', top: 20, right: 20, backgroundColor: 'rgba(0,0,0,0.5)', color: 'white', zIndex: 100 }}
                    onClick={handleClose}
                >
                    <Close />
                </IconButton>
                <div style={{ position: 'relative', padding: '0', textAlign: 'center', width: '100%', height: '100vh', backgroundColor: '#555' }}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} sm={12} md={10} lg={8} style={{ height: '100vh' }}>
                            <div id={'container-pdf'} style={{ height: '100%', width: '100%', overflowY: 'auto', padding: '10px' }}>
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                    {file && (
                                        <div style={{ height: '100%' }}>
                                            <Viewer
                                                fileUrl={file}
                                                plugins={[defaultLayoutPluginInstance]}
                                            />
                                        </div>
                                    )}
                                </Worker>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
        </div>
    )
}

export default PDFFileDialog
